import { render, staticRenderFns } from "./CheckDataPanels.vue?vue&type=template&id=2d2c7e99&"
import script from "./CheckDataPanels.vue?vue&type=script&lang=js&"
export * from "./CheckDataPanels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports